
import { USER_LOGGED,UNAUTORIZED_ACCES,AUTH_ERROR,SET_ACTIVE_CLIENT } from '../actions/authenticationActions.js'


const initialState = {
    user:{},
    JWTToken:'',
    clients : [],
    authorized:false,
    currentClient: undefined,
    error:''
};

const authentication = (state = initialState, action)=> {
    switch (action.type) {
        case USER_LOGGED:{
            return {
                ...state,
                user:action.decoded ,
                authorized:true,
                JWTToken: action.token,
                clients : action.clients,
                currentClient:  action.clients[0],
                error:''
            }
        }
        case UNAUTORIZED_ACCES:{
            return {
                ...state,
                JWTToken:'',
                user:{},
                clients:[],
                currentClient: undefined,
                authorized:false,
                error:''
            }
        }
        case SET_ACTIVE_CLIENT:{
            return {
                ...state,
                JWTToken: action.token,
                currentClient: state.clients.find(value=> value.numero===action.decoded.numclient)
            }
        }
        case AUTH_ERROR:{
            const {error}=action
            return {
                ...state,
                JWTToken:'',
                user:{},
                clients:[],
                currentClient: undefined,
                authorized:false,
                error:error
            }
        }

        default:
            return state;
    }

}

export default authentication